
export default function getPageTitle(pageTitle,ctitle) {
  if(ctitle == undefined && pageTitle){
    document.title = pageTitle;
    return true;
  }

  if(ctitle != undefined && ctitle.length > 0 && pageTitle){
    ctitle = ctitle.replace(/\s+/g, '');
    document.title = `${pageTitle} - ${ctitle}`;
    return true;
  }
	
  // return '页面加载中...'
}